export const UploadType = {
    EXERCISE_VIDEOS: 'exerciseVideos',
    OVERVIEW_VIDEOS: 'overviewVideos',
    WELCOME_VIDEO: 'welcomeVideo',
};